/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
import { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import apiBackendInstance from '../../../utils/axios';
import BaseUrls from '../../../utils/baseUrls';

import { prefixPath } from '../../../utils/helpers';
import Urls from '../../../utils/urls';
import ServiceCard from './serviceCard';

export interface subscriptionItem{
  protocolType?: string,
  frontendBaseSuburl?: string,
  protocol_name: string,
  subscribe_more_url: string,
  update_subscription_url: string,
    subscription_details: {
      subscriptionId: string,
      subscriptionModifiable?: boolean,
      subscriptionStatus?: string,
      plan: {
      plan_code: string,
      total_quantity: number,
      available_quantity: number,
      },
      addons: {
        addon_code: string,
        name: string,
        total_quantity: number,
        available_quantity: number
        price: number,
      description: string,
      costDescription: string
      }[],
      amount: number,
      next_billing_date: string,
}
}
const SubscriptionBody = () => {
  const theme = BaseUrls.getkey();
  const baseUrl = window.location.origin;
  const loaderUrl = baseUrl + prefixPath(`/img/${theme}/spin.svg`);
  const [subscriptionData, setSubscriptionData] = useState([] as subscriptionItem[]);
  const [totalCost, setTotalCost] = useState(-1);

  const getTotalCost = (data: subscriptionItem[]) => {
    let cost = 0;
    for (let i = 0; i < data.length; i += 1) {
      cost += data[i].subscription_details.amount;
    }
    return cost;
  };
  useEffect(() => {
    let isActive = true;
    showLoader();
    apiBackendInstance.get(Urls.getSubscriptionSummary(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (isActive && response && response.data && response.data.data) {
        setSubscriptionData(response.data.data);
        setTotalCost(getTotalCost(response.data.data));
      }
      hideLoader();
    }).catch(() => {
      setSubscriptionData([]);
      setTotalCost(0);
      hideLoader();
    });

    return () => { isActive = false; };
  }, []);

  const showLoader = () => {
    const spinner = document.getElementById('spinnerDiv');
    if (spinner) spinner.style.display = 'block';
  };
  const hideLoader = () => {
    const spinner = document.getElementById('spinnerDiv');
    if (spinner) spinner.style.display = 'none';
  };
  return (
    <section className="pe-5 col-12">
        <div className="mt-5 mx-auto">
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mt-2">
                <div className="card cloud-details" style={{ borderRadius: '8px' }}>
                  <div className="card-body">
                    <div className="d-flex justify-content-center align-items-center">

                          <h6 className="mb-0">Total Monthly Subscription :</h6>

                          <h6 className="mb-0">
                          {
                            totalCost === -1
                              && <span className="mx-3">Loading</span>
                          }
                          { totalCost !== -1
                            && <NumberFormat className="mx-3" value={totalCost} displayType="text" decimalScale={2} thousandSeparator prefix="$ " />}
                          </h6>
                    </div>

                  </div>
                </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 mt-2 col-sm-12 ">
                <div className="card cloud-details" style={{ borderRadius: '8px' }}>
                  <div className="card-body">
                    <div className="d-flex justify-content-center align-items-center">
                      <h6 className="mb-0">
                        <span>Current Plan : </span>
                      </h6>
                      <h6 className="mx-3 mb-0">
                        {' '}
                        Standard
                      </h6>
                    </div>
                  </div>
                </div>
                </div>
            </div>
            <div className="overflow-auto ">
          <div className="d-flex mt-5">
            <div
              className="col-xl-2 col-lg-3 col-md-3 col-sm-3"
              style={{
                display: 'flex', justifyContent: 'center',
              }}
            >
                <b>Services</b>
            </div>
            <div
              className="col-xl-2 col-lg-3 col-md-3 col-sm-3"
              style={{
                display: 'flex', justifyContent: 'center',
              }}
            >
                <b>Monthly Cost</b>
            </div>
            <div
              className="col-xl-2 col-lg-3 col-md-3 col-sm-3"
              style={{
                display: 'flex', justifyContent: 'center',
              }}
            >
                    <b>Next Billing Cycle</b>
            </div>

            <div
              className="col-xl-2 col-lg-3 col-md-3 col-sm-3"
              style={{
                display: 'flex', justifyContent: 'center',
              }}
            >
                <b>Total Subscribed</b>
            </div>
            <div
              className="col-xl-1 col-lg-2 col-md-3 col-sm-2"
              style={{
                display: 'flex', justifyContent: 'center',
              }}
            >
                <b>Available</b>
            </div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 " />
          </div>
            <hr className="my-2 hrwidth" />
            {subscriptionData.length > 0
              ? subscriptionData.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <ServiceCard index={index} key={index.toString()} item={item} />
              )) : null}
            {totalCost !== -1 && subscriptionData.length === 0
             && (
            <div className="mt-5" style={{ color: '#ABB2B9', textAlign: 'center', fontSize: '20px' }}>
             No Data
            </div>
             )}
              <div
                    id="spinnerDiv"
                    className="text-center mx-5 p-3 col-11 "
                    style={{ display: 'none' }}
              >
                    <img className="" style={{ margin: 'auto' }} src={loaderUrl} alt="spinnner" />
              </div>
            </div>
        </div>
    </section>
  );
};
export default SubscriptionBody;